/* ***********************************
swiper

*********************************** */
jQuery(function($) {
//swiper 768以下で起動
var swiper;
$(window).on('load resize', function() {
var w = $(window).width();
if (w <= 768) {
if (swiper) {
return;
} else {
swiper = new Swiper('.swiper-container', {
loop: true,
speed: 2000,
slidesPerView: 1.25,
centeredSlides: true,
autoplay: {
delay: 3500,
},
// pagination: {
// el: '.swiper-pagination',
// type: 'bullets',
// clickable: true
// },
});
}
} else {
if (swiper) {
swiper.destroy();
swiper = undefined;
}
}
});
});

/* ***********************************
画像固定

*********************************** */
jQuery(window).on('load resize', function() {
var windowWidth = window.innerWidth;
var elements = jQuery('.fixed-area');
if (windowWidth >= 768) {
Stickyfill.add(elements);
} else {
Stickyfill.remove(elements);
}
});





